var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.25C7 4.45833 7.07292 4.63542 7.21875 4.78125C7.36458 4.92708 7.54167 5 7.75 5H12V15.25C12 15.4583 11.9271 15.6354 11.7812 15.7812C11.6354 15.9271 11.4583 16 11.25 16H0.75C0.541667 16 0.364583 15.9271 0.21875 15.7812C0.0729167 15.6354 0 15.4583 0 15.25V0.75C0 0.541667 0.0729167 0.364583 0.21875 0.21875C0.364583 0.0729167 0.541667 0 0.75 0H7V4.25ZM9.375 10.8438C9.54167 10.6979 9.58333 10.5208 9.5 10.3125C9.41667 10.1042 9.26042 10 9.03125 10H7V7.5C7 7.35417 6.94792 7.23958 6.84375 7.15625C6.76042 7.05208 6.64583 7 6.5 7H5.5C5.35417 7 5.22917 7.05208 5.125 7.15625C5.04167 7.23958 5 7.35417 5 7.5V10H2.96875C2.73958 10 2.58333 10.1042 2.5 10.3125C2.41667 10.5208 2.45833 10.6979 2.625 10.8438L5.625 13.8438C5.72917 13.9479 5.85417 14 6 14C6.14583 14 6.27083 13.9479 6.375 13.8438L9.375 10.8438ZM11.7812 3.28125C11.9271 3.42708 12 3.60417 12 3.8125V4H8V0H8.1875C8.39583 0 8.57292 0.0729167 8.71875 0.21875L11.7812 3.28125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.387a38aa5571a520ce7e4636bdd64058.svg";
export { ForwardRef as ReactComponent };